export enum GameState {
    Lobby,
    InGame,
    PostGame
}

export enum SPGameState {
    Title,
    HowToPlay,
    InGame,
    GameOver,
    AbilityPick,
    Pause
}